import styled from "styled-components";
import {
  PrimaryButtonComponent,
  DisplayFlex
} from "../../../../../../CommonComponents/commonStyles";

export const ClearTimeMob = styled.div`
  position: relative;
  float: left;
  max-width: 100%;
  line-height: 30px;
  height: 30px;
  margin: 4px 2px;
  padding: 0 10px 0 10px;
  font-size: 12px;
  // overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  background-color: ${props => props.theme.colors.greyColor};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 2px;
  cursor: default;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
`;

export const PickTimeFrame = styled.div`
  font-size: ${props => props.theme.fontSize.h4};
  margin-top: 30px;
  width: 100%;
  text-align: center;
  color: ${props => props.theme.fontColors.headingColor};
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
`;

export const CloseIcon = styled.img`
  font-size: ${props => props.theme.fontSize.secondary};
  margin-left: 5px;
  line-height: 30px;
  width: auto;
  height: ${props => props.theme.fontSize.secondary};
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const TimeFramed = styled.div`
  height: 40px;
  border-radius: 0px;
  border: 1px solid ${props => props.theme.colors.border};
  line-height: 40px;

  background: ${props => props.theme.colors.white};
  font-size: 14px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  color: ${props => props.theme.colors.border};
`;

export const QASection = styled.div`
    position: absolute;
    left: 48%;
    top: 58%;
    transform: translate(-50%, -50%);
// margin-top: ${props => props.borderTop}
  // height: 100%;
//   height: 66.4%;
`;

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`;
export const InfoContentWrapper = styled.div`
padding: 0 30px 30px 30px;
position: fixed;
background: ${props => props.theme.backgroundColor.layoutLight};
width: 56%;
height: auto;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
z-index: 1000!important;
.ant-calendar-picker-container{
left: 0px !important;
top: 0px !important;
width:100%;
.ant-calendar-range{
  width:100%;
}
}
.ant-calendar-input-wrap{
  border-bottom: 0;
  @media only screen and (max-width: 767px){
    .ant-calendar-date-input-wrap{
      input{
        text-align: center;
      }
    }
  }
}
.ant-calendar-selected-day .ant-calendar-date{
  background: #69923a !important;
    color: #ffffff !important;
}
.ant-calendar-range .ant-calendar-body, .ant-calendar-range .ant-calendar-month-panel-body, .ant-calendar-range .ant-calendar-year-panel-body{
  border-top: 0;
}
.ant-calendar{
  box-shadow: 0 0 0 rgba(0,0,0,0) !important;
}
.ant-calendar-range-left .ant-calendar-input, .ant-calendar-range-left .ant-calendar-time-picker-input{
  text-align: center;
}
.ant-calendar-range-right .ant-calendar-input, .ant-calendar-range-right .ant-calendar-time-picker-input{
  text-align: center;
  margin-left: 45px;
}
.ant-calendar-range-middle {
  padding-left:201px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  padding: 0 10px 30px 10px;
  .ant-calendar-picker-container{
    position: relative;
    left: unset !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  height: auto;
  width: 87.5%;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  height: auto;
  width: 74%;
}
@media screen and (min-width: 1440px) {
  height: auto;
  width: 39.5%;
}
`;

export const PrimaryButtonOkay = styled(PrimaryButtonComponent)`
width: 200px;
border-radius: 0;
font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
font-size: ${props => props.theme.fontSize.heading};
letter-spacing: ${props => props.theme.letterSpacing.buttonText};
cursor: pointer;
border: none;
z-index: 1000; 
@media only screen and (max-width: 990px) {
width:41%;
}
`;

export const InfoWrapper = styled.div`
  position: fixed;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  //overflow: none !important;
  top: 0;
`;

export const TimeFrames = styled.div`
  position: relative;
  min-width: 180px;
  height: 40px;
  border-radius: 0px;
  margin-left: 10px;
  border: 1px solid ${props => props.theme.colors.border};
  line-height: 40px;
  padding-left: 12px;
  background: ${props => props.theme.colors.white};
  color: ${props => props.theme.fontColors.placeholder};
  font-size: ${props => props.theme.fontSize.secondary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  @media only screen and (max-width: 576px) {
    min-width: 170px;
    height: 40px;
    border-radius: 0px;
    margin-left: 0px;
  }
`;

export const ClearTime = styled.div`
  position: absolute;
  width: 92%;
  max-width: 100%;
  line-height: 30px;
  font-size: ${props => props.theme.fontSize.tertiary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  height: 30px;
  margin-top: 3px;
  padding: 0 5px 0 5px;
  display: flex;
  // overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  background-color: ${props => props.theme.colors.greyColor};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 2px;
  cursor: default;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
`;

export const DisplayFlexOkay = styled(DisplayFlex)`
justify-content: center;
align-items: center;
height: 18.6%;
padding: 10px 16px 0px 16px;
`;

export const PopHeader = styled.div`
font-family: ${props => props.theme.fontFamily.berkeleyStd}!important;
font-size: ${props => props.theme.fontSize.h4};
line-height: ${props => props.theme.lineHeight.secondary};
letter-spacing: ${props => props.theme.letterSpacing.normal};
color: ${props => props.theme.fontColors.headingColor}!important;
text-align: center;
display: flex;
align-items: center;
justify-content: center;
margin-top: 30px;
height: 15% @media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.h5};
}
`;

export const QASectionWrapper = styled.div`
  margin: 15px 0 9px 0;
`;

export const IconWrap = styled.div`
position: absolute;
right: 23px;
cursor: pointer;
margin-top: 23px;
i {
  font-size: ${props => props.theme.fontSize.h5};
  color: ${props => props.theme.fontColors.textColor};
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-right: 0;
}
`;

export const CalenderClear = styled.span`
  cursor: pointer;
  padding-right: 5px;
  padding-left: 3px;
`;
